import { render, staticRenderFns } from "./Segmento.vue?vue&type=template&id=d29c45ee&scoped=true&"
import script from "./Segmento.vue?vue&type=script&lang=js&"
export * from "./Segmento.vue?vue&type=script&lang=js&"
import style0 from "./Segmento.vue?vue&type=style&index=0&id=d29c45ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29c45ee",
  null
  
)

export default component.exports